var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4AxSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3033.03 738.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264,.cls-265,.cls-266{stroke-width:0px;}.cls-2,.cls-262{fill:#414042;}.cls-3,.cls-7,.cls-131,.cls-267,.cls-241,.cls-242,.cls-244,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-262,.cls-265{mix-blend-mode:multiply;}.cls-3,.cls-228{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_5);}.cls-6{fill:url(#New_Gradient_Swatch_3);}.cls-7{fill:url(#linear-gradient-5);}.cls-268{filter:url(#luminosity-noclip-2);}.cls-269{filter:url(#luminosity-noclip-3);}.cls-270{filter:url(#luminosity-noclip-5);}.cls-8{fill:url(#New_Gradient_Swatch_5-2);}.cls-9{fill:url(#New_Gradient_Swatch_3-3);}.cls-10{fill:url(#New_Gradient_Swatch_3-4);}.cls-11{fill:url(#New_Gradient_Swatch_3-9);}.cls-12{fill:url(#New_Gradient_Swatch_3-8);}.cls-13{fill:url(#New_Gradient_Swatch_3-7);}.cls-14{fill:url(#New_Gradient_Swatch_3-6);}.cls-15{fill:url(#New_Gradient_Swatch_3-2);}.cls-16{fill:url(#New_Gradient_Swatch_3-5);}.cls-17{fill:url(#New_Gradient_Swatch_4-3);}.cls-18{fill:url(#New_Gradient_Swatch_4-2);}.cls-19{fill:url(#New_Gradient_Swatch_4-4);}.cls-20{fill:url(#linear-gradient-179);}.cls-21{fill:url(#linear-gradient-177);}.cls-22{fill:url(#linear-gradient-176);}.cls-23{fill:url(#linear-gradient-178);}.cls-24{fill:url(#linear-gradient-120);}.cls-25{fill:url(#linear-gradient-125);}.cls-26{fill:url(#linear-gradient-124);}.cls-27{fill:url(#linear-gradient-126);}.cls-28{fill:url(#linear-gradient-180);}.cls-29{fill:url(#linear-gradient-184);}.cls-30{fill:url(#linear-gradient-185);}.cls-31{fill:url(#linear-gradient-181);}.cls-32{fill:url(#linear-gradient-182);}.cls-33{fill:url(#linear-gradient-183);}.cls-34{fill:url(#linear-gradient-138);}.cls-35{fill:url(#linear-gradient-139);}.cls-36{fill:url(#linear-gradient-134);}.cls-37{fill:url(#linear-gradient-131);}.cls-38{fill:url(#linear-gradient-136);}.cls-39{fill:url(#linear-gradient-132);}.cls-40{fill:url(#linear-gradient-135);}.cls-41{fill:url(#linear-gradient-130);}.cls-42{fill:url(#linear-gradient-133);}.cls-43{fill:url(#linear-gradient-137);}.cls-44{fill:url(#linear-gradient-197);}.cls-45{fill:url(#linear-gradient-196);}.cls-46{fill:url(#linear-gradient-195);}.cls-47{fill:url(#linear-gradient-194);}.cls-48{fill:url(#linear-gradient-199);}.cls-49{fill:url(#linear-gradient-100);}.cls-50{fill:url(#linear-gradient-101);}.cls-51{fill:url(#linear-gradient-192);}.cls-52{fill:url(#linear-gradient-193);}.cls-53{fill:url(#linear-gradient-198);}.cls-54{fill:url(#linear-gradient-123);}.cls-55{fill:url(#linear-gradient-129);}.cls-56{fill:url(#linear-gradient-121);}.cls-57{fill:url(#linear-gradient-122);}.cls-58{fill:url(#linear-gradient-109);}.cls-59{fill:url(#linear-gradient-108);}.cls-60{fill:url(#linear-gradient-106);}.cls-61{fill:url(#linear-gradient-107);}.cls-62{fill:url(#linear-gradient-102);}.cls-63{fill:url(#linear-gradient-104);}.cls-64{fill:url(#linear-gradient-103);}.cls-65{fill:url(#linear-gradient-105);}.cls-66{fill:url(#linear-gradient-117);}.cls-67{fill:url(#linear-gradient-118);}.cls-68{fill:url(#linear-gradient-111);}.cls-69{fill:url(#linear-gradient-112);}.cls-70{fill:url(#linear-gradient-127);}.cls-71{fill:url(#linear-gradient-128);}.cls-72{fill:url(#linear-gradient-110);}.cls-73{fill:url(#linear-gradient-113);}.cls-74{fill:url(#linear-gradient-114);}.cls-75{fill:url(#linear-gradient-115);}.cls-76{fill:url(#linear-gradient-116);}.cls-77{fill:url(#linear-gradient-119);}.cls-78{fill:url(#linear-gradient-173);}.cls-79{fill:url(#linear-gradient-170);}.cls-80{fill:url(#linear-gradient-175);}.cls-81{fill:url(#linear-gradient-174);}.cls-82{fill:url(#linear-gradient-172);}.cls-83{fill:url(#linear-gradient-144);}.cls-84{fill:url(#linear-gradient-145);}.cls-85{fill:url(#linear-gradient-149);}.cls-86{fill:url(#linear-gradient-148);}.cls-87{fill:url(#linear-gradient-171);}.cls-88{fill:url(#linear-gradient-146);}.cls-89{fill:url(#linear-gradient-143);}.cls-90{fill:url(#linear-gradient-169);}.cls-91{fill:url(#linear-gradient-140);}.cls-92{fill:url(#linear-gradient-141);}.cls-93{fill:url(#linear-gradient-147);}.cls-94{fill:url(#linear-gradient-166);}.cls-95{fill:url(#linear-gradient-142);}.cls-96{fill:url(#linear-gradient-168);}.cls-97{fill:url(#linear-gradient-164);}.cls-98{fill:url(#linear-gradient-161);}.cls-99{fill:url(#linear-gradient-163);}.cls-100{fill:url(#linear-gradient-158);}.cls-101{fill:url(#linear-gradient-160);}.cls-102{fill:url(#linear-gradient-159);}.cls-103{fill:url(#linear-gradient-167);}.cls-104{fill:url(#linear-gradient-162);}.cls-105{fill:url(#linear-gradient-165);}.cls-106{fill:url(#linear-gradient-154);}.cls-107{fill:url(#linear-gradient-152);}.cls-108{fill:url(#linear-gradient-157);}.cls-109{fill:url(#linear-gradient-155);}.cls-110{fill:url(#linear-gradient-151);}.cls-111{fill:url(#linear-gradient-153);}.cls-112{fill:url(#linear-gradient-150);}.cls-113{fill:url(#linear-gradient-156);}.cls-114{fill:url(#linear-gradient-209);}.cls-115{fill:url(#linear-gradient-213);}.cls-116{fill:url(#linear-gradient-211);}.cls-117{fill:url(#linear-gradient-214);}.cls-118{fill:url(#linear-gradient-215);}.cls-119{fill:url(#linear-gradient-217);}.cls-120{fill:url(#linear-gradient-212);}.cls-121{fill:url(#linear-gradient-208);}.cls-122{fill:url(#linear-gradient-205);}.cls-123{fill:url(#linear-gradient-201);}.cls-124{fill:url(#linear-gradient-203);}.cls-125{fill:url(#linear-gradient-204);}.cls-126{fill:url(#linear-gradient-206);}.cls-127{fill:url(#linear-gradient-200);}.cls-128{fill:url(#linear-gradient-202);}.cls-129{fill:url(#linear-gradient-210);}.cls-130{fill:url(#linear-gradient-216);}.cls-271{mask:url(#mask);}.cls-131,.cls-264{fill:#fff;}.cls-132,.cls-242{fill:#ed1c24;}.cls-133{fill:url(#linear-gradient);}.cls-272{filter:url(#luminosity-noclip);}.cls-134{fill:#ef4136;}.cls-135,.cls-241{fill:#6d6e71;}.cls-136{fill:#f15a29;}.cls-137{fill:url(#linear-gradient-38);}.cls-138{fill:url(#linear-gradient-33);}.cls-139{fill:url(#linear-gradient-29);}.cls-140{fill:url(#linear-gradient-32);}.cls-141{fill:url(#linear-gradient-30);}.cls-142{fill:url(#linear-gradient-31);}.cls-143{fill:url(#linear-gradient-36);}.cls-144{fill:url(#linear-gradient-39);}.cls-145{fill:url(#linear-gradient-34);}.cls-146{fill:url(#linear-gradient-37);}.cls-147{fill:url(#linear-gradient-35);}.cls-148{fill:url(#linear-gradient-28);}.cls-149{fill:url(#linear-gradient-25);}.cls-150{fill:url(#linear-gradient-11);}.cls-151{fill:url(#linear-gradient-12);}.cls-152{fill:url(#linear-gradient-13);}.cls-153{fill:url(#linear-gradient-10);}.cls-154{fill:url(#linear-gradient-17);}.cls-155{fill:url(#linear-gradient-16);}.cls-156{fill:url(#linear-gradient-19);}.cls-157{fill:url(#linear-gradient-15);}.cls-158{fill:url(#linear-gradient-23);}.cls-159{fill:url(#linear-gradient-21);}.cls-160{fill:url(#linear-gradient-18);}.cls-161{fill:url(#linear-gradient-14);}.cls-162{fill:url(#linear-gradient-22);}.cls-163{fill:url(#linear-gradient-20);}.cls-164{fill:url(#linear-gradient-27);}.cls-165{fill:url(#linear-gradient-24);}.cls-166{fill:url(#linear-gradient-26);}.cls-167{fill:url(#linear-gradient-45);}.cls-168{fill:url(#linear-gradient-46);}.cls-169{fill:url(#linear-gradient-44);}.cls-170{fill:url(#linear-gradient-48);}.cls-171{fill:url(#linear-gradient-49);}.cls-172{fill:url(#linear-gradient-47);}.cls-173{fill:url(#linear-gradient-42);}.cls-174{fill:url(#linear-gradient-43);}.cls-175{fill:url(#linear-gradient-40);}.cls-176{fill:url(#linear-gradient-41);}.cls-177{fill:url(#linear-gradient-59);}.cls-178{fill:url(#linear-gradient-57);}.cls-179{fill:url(#linear-gradient-58);}.cls-180{fill:url(#linear-gradient-55);}.cls-181{fill:url(#linear-gradient-56);}.cls-182{fill:url(#linear-gradient-53);}.cls-183{fill:url(#linear-gradient-51);}.cls-184{fill:url(#linear-gradient-52);}.cls-185{fill:url(#linear-gradient-50);}.cls-186{fill:url(#linear-gradient-54);}.cls-187{fill:url(#linear-gradient-60);}.cls-188{fill:url(#linear-gradient-61);}.cls-189{fill:url(#linear-gradient-62);}.cls-190{fill:url(#linear-gradient-65);}.cls-191{fill:url(#linear-gradient-79);}.cls-192{fill:url(#linear-gradient-78);}.cls-193{fill:url(#linear-gradient-77);}.cls-194{fill:url(#linear-gradient-75);}.cls-195{fill:url(#linear-gradient-76);}.cls-196{fill:url(#linear-gradient-74);}.cls-197{fill:url(#linear-gradient-67);}.cls-198{fill:url(#linear-gradient-68);}.cls-199{fill:url(#linear-gradient-66);}.cls-200{fill:url(#linear-gradient-63);}.cls-201{fill:url(#linear-gradient-69);}.cls-202{fill:url(#linear-gradient-64);}.cls-203{fill:url(#linear-gradient-71);}.cls-204{fill:url(#linear-gradient-72);}.cls-205{fill:url(#linear-gradient-70);}.cls-206{fill:url(#linear-gradient-73);}.cls-207{fill:url(#linear-gradient-84);}.cls-208{fill:url(#linear-gradient-85);}.cls-209{fill:url(#linear-gradient-82);}.cls-210{fill:url(#linear-gradient-83);}.cls-211{fill:url(#linear-gradient-89);}.cls-212{fill:url(#linear-gradient-88);}.cls-213{fill:url(#linear-gradient-86);}.cls-214{fill:url(#linear-gradient-87);}.cls-215{fill:url(#linear-gradient-80);}.cls-216{fill:url(#linear-gradient-81);}.cls-217{fill:url(#linear-gradient-98);}.cls-218{fill:url(#linear-gradient-91);}.cls-219{fill:url(#linear-gradient-92);}.cls-220{fill:url(#linear-gradient-93);}.cls-221{fill:url(#linear-gradient-90);}.cls-222{fill:url(#linear-gradient-96);}.cls-223{fill:url(#linear-gradient-97);}.cls-224{fill:url(#linear-gradient-94);}.cls-225{fill:url(#linear-gradient-95);}.cls-226{fill:url(#linear-gradient-99);}.cls-227{fill:#3c2415;}.cls-229{fill:#58595b;}.cls-230{fill:#bcbec0;}.cls-231{fill:#808285;}.cls-232{fill:url(#New_Gradient_Swatch_3-12);}.cls-233{fill:url(#New_Gradient_Swatch_3-11);}.cls-234{fill:url(#New_Gradient_Swatch_3-10);}.cls-235{fill:url(#New_Gradient_Swatch_3-14);}.cls-236{fill:url(#New_Gradient_Swatch_3-13);}.cls-237{fill:url(#New_Gradient_Swatch_3-15);}.cls-238,.cls-245{fill:#000;}.cls-239,.cls-244{fill:#a7a9ac;}.cls-240{fill:url(#New_Gradient_Swatch_11_cop);}.cls-243{fill:#be1e2d;}.cls-245{opacity:.5;}.cls-246{fill:url(#linear-gradient-4);}.cls-247{fill:url(#linear-gradient-2);}.cls-248{fill:url(#linear-gradient-3);}.cls-249{fill:url(#linear-gradient-8);}.cls-250{fill:url(#linear-gradient-9);}.cls-251{fill:url(#linear-gradient-7);}.cls-252{fill:url(#linear-gradient-6);}.cls-253{fill:url(#linear-gradient-207);}.cls-254{fill:url(#linear-gradient-190);}.cls-255{fill:url(#linear-gradient-189);}.cls-256{fill:url(#linear-gradient-191);}.cls-257{fill:url(#linear-gradient-186);}.cls-258{fill:url(#linear-gradient-187);}.cls-259{fill:url(#linear-gradient-188);}.cls-273{isolation:isolate;}.cls-260{fill:#e6e7e8;}.cls-261{fill:#c49a6c;}.cls-263{fill:#d1d3d4;}.cls-265{fill:#939598;}.cls-274{mask:url(#mask-3);}.cls-275{mask:url(#mask-2);}.cls-276{mask:url(#mask-5);}.cls-277{mask:url(#mask-4);}.cls-278{mask:url(#mask-1);}.cls-266{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 650.76,
    width: 1548.62,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 650.76,
    width: 1548.62,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1550,
    height: 88,
    transform: "translate(-.99 650.52)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1858.89,
    y: 650.76,
    width: 1174.14,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 1858.89,
    y: 650.76,
    width: 1174.14,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1176,
    height: 88,
    transform: "translate(1858.01 650.52)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1528.59,
    y1: 515.89,
    x2: 1636.93,
    y2: 515.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1592.63,
    y1: 525.96,
    x2: 1636.93,
    y2: 525.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#322f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 505.81,
    y2: 505.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1647.51,
    y1: 515.89,
    x2: 1887.87,
    y2: 515.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1647.51,
    y1: 515.82,
    x2: 1887.5,
    y2: 515.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5062.54,
    y1: -1443.57,
    x2: -5062.54,
    y2: -1459.01,
    gradientTransform: "translate(6594.4 1985.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c5d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#737376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1532.1,
    y1: 481.65,
    x2: 1574.99,
    y2: 481.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1529.81,
    y1: 535.76,
    x2: 1529.81,
    y2: 532.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 532.39,
    y2: 529.07,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1530.57,
    y1: 505.35,
    x2: 1530.57,
    y2: 480.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1529.81,
    y1: 530.42,
    x2: 1529.81,
    y2: 526.09,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1495.27,
    y1: 515.42,
    x2: 1540.3,
    y2: 515.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1544.79,
    y1: 518.11,
    x2: 1565.34,
    y2: 518.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#67686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9d9e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1883.86,
    y1: 510.99,
    x2: 2188.89,
    y2: 510.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#302f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1915.17,
    y1: 478.79,
    x2: 1915.17,
    y2: 448.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3f3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#393739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e2c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1889.93,
    x2: 1889.93,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1923.15,
    x2: 1923.15,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2149.98,
    x2: 2149.98,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2157.95,
    x2: 2157.95,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2183.04,
    x2: 2183.04,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 2061.66,
    y1: 651.63,
    x2: 2061.66,
    y2: 464.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 2061.66,
    y1: 481.75,
    x2: 2061.66,
    y2: 640.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2061.66,
    y1: 616.42,
    x2: 2061.66,
    y2: 501.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2061.63,
    y1: 507.79,
    x2: 2061.63,
    y2: 608.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2061.66,
    y1: 576.89,
    x2: 2061.66,
    y2: 539.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2061.66,
    y1: 572,
    x2: 2061.66,
    y2: 545.38,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 3188.71,
    y1: 4658.5,
    x2: 3188.71,
    y2: 4479.81,
    gradientTransform: "translate(-2088.33 3696.05) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 3210.63,
    y1: 4476.83,
    x2: 3210.63,
    y2: 4661.3,
    gradientTransform: "translate(5782.97 5146.1) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5780.39 5143.52) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 4476.84,
    y2: 4661.3,
    gradientTransform: "translate(5777.21 5140.34) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5773.39 5136.51) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5768.89 5132.01) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5763.84 5126.97) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5758.26 5121.39) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5752.21 5115.34) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5745.54 5108.67) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5738.61 5101.74) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5731.18 5094.31) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5723.52 5086.65) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5715.51 5078.64) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5707.39 5070.52) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(5699.17 5062.3) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-821.57 -3991.97)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-818.99 -3994.55)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 4476.83,
    y2: 4661.31,
    gradientTransform: "translate(-815.81 -3997.73)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-811.99 -4001.55)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-807.49 -4006.05)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-802.45 -4011.09)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-796.86 -4016.68)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-790.81 -4022.73)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-784.14 -4029.4)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-777.21 -4036.33)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-769.78 -4043.76)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-762.13 -4051.41)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-754.11 -4059.43)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-745.99 -4067.55)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 4476.83,
    y2: 4661.3,
    gradientTransform: "translate(-737.77 -4075.77)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 3210.63,
    y1: 4476.83,
    x2: 3210.63,
    y2: 4661.3,
    gradientTransform: "translate(-729.93 -4083.61)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 3166.79,
    x2: 3166.79,
    gradientTransform: "translate(5739.13 5189.93) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5736.56 5187.36) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 3166.79,
    y1: 4476.84,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5733.38 5184.18) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5729.55 5180.35) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5725.05 5175.85) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5720.01 5170.81) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5714.43 5165.22) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5708.38 5159.17) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5701.7 5152.5) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5694.78 5145.57) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5687.34 5138.14) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5679.69 5130.49) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5671.67 5122.47) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5663.56 5114.35) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(5655.33 5106.13) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-777.74 -3948.13)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-775.16 -3950.71)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.31,
    gradientTransform: "translate(-771.98 -3953.89)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-768.15 -3957.72)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-763.65 -3962.22)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-758.61 -3967.26)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-753.03 -3972.84)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-746.98 -3978.89)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-740.31 -3985.56)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-733.38 -3992.49)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-725.94 -3999.93)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-718.29 -4007.58)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-710.28 -4015.59)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-702.16 -4023.71)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-693.93 -4031.94)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 3166.79,
    y1: 4476.83,
    x2: 3166.79,
    y2: 4661.3,
    gradientTransform: "translate(-686.09 -4039.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 3188.71,
    y1: 4478.33,
    x2: 3188.71,
    y2: 4661.8,
    gradientTransform: "translate(-708.01 -4061.7)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 2862.16,
    y1: 542.75,
    x2: 2862.16,
    y2: 479.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#353436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#171617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 3007.91,
    y1: 453.09,
    x2: 3007.91,
    y2: 499.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 3018.76,
    y1: 538.42,
    x2: 3018.76,
    y2: 555.42,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 3007.29,
    y1: 418.72,
    x2: 3007.29,
    y2: 572.17,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 762.54,
    y1: 3049.66,
    x2: 762.54,
    y2: 3068.1,
    gradientTransform: "translate(3791.4 3546.86) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 3028.86,
    y1: 455.63,
    x2: 3028.86,
    y2: 475.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 2862.16,
    x2: 2862.16,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 2862.16,
    x2: 2862.16,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 2862.16,
    x2: 2862.16,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 2862.13,
    x2: 2862.13,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 2862.16,
    x2: 2862.16,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 2862.16,
    y1: 572,
    x2: 2862.16,
    y2: 545.38,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 868.57,
    y1: 510.03,
    x2: 868.57,
    y2: 542.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 4145.72,
    y1: 4902.7,
    x2: 4145.72,
    y2: 4724.02,
    gradientTransform: "translate(-3418.33 4689.64) rotate(-90)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5653.76 5427.32) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 4167.2,
    y1: 4721.03,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5651.18 5424.75) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5648 5421.57) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5644.18 5417.74) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5639.68 5413.24) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5634.63 5408.2) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5629.05 5402.61) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5623 5396.56) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5616.33 5389.89) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5609.4 5382.97) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5601.97 5375.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5594.31 5367.88) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5586.3 5359.86) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5578.18 5351.75) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(5569.96 5343.52) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.52,
    gradientTransform: "translate(-2863.93 -4199.16)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.52,
    gradientTransform: "translate(-2861.35 -4201.74)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.5,
    gradientTransform: "translate(-2858.17 -4204.92)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2854.35 -4208.74)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.52,
    gradientTransform: "translate(-2849.85 -4213.24)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2844.81 -4218.28)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2839.22 -4223.87)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2833.17 -4229.92)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2826.5 -4236.59)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2819.57 -4243.52)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2812.14 -4250.95)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2804.49 -4258.6)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2796.47 -4266.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2788.35 -4274.74)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2780.13 -4282.96)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 4167.2,
    y1: 4721.04,
    x2: 4167.2,
    y2: 4905.51,
    gradientTransform: "translate(-2772.29 -4290.8)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5610.79 5470.29) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 4124.23,
    y1: 4721.03,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5608.21 5467.71) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5605.03 5464.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5601.21 5460.71) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5596.71 5456.21) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5591.67 5451.17) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5586.08 5445.58) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5580.03 5439.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5573.36 5432.86) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5566.43 5425.93) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5559 5418.5) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5551.35 5410.85) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5543.33 5402.83) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5535.21 5394.71) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(5526.99 5386.49) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.52,
    gradientTransform: "translate(-2820.96 -4156.19)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.52,
    gradientTransform: "translate(-2818.39 -4158.77)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.5,
    gradientTransform: "translate(-2815.2 -4161.95)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2811.38 -4165.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.52,
    gradientTransform: "translate(-2806.88 -4170.27)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2801.84 -4175.32)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2796.25 -4180.9)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2790.2 -4186.95)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2783.53 -4193.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2776.6 -4200.55)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2769.17 -4207.98)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2761.52 -4215.64)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2753.5 -4223.65)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2745.38 -4231.77)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2737.16 -4239.99)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 4124.23,
    y1: 4721.04,
    x2: 4124.23,
    y2: 4905.51,
    gradientTransform: "translate(-2729.32 -4247.83)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 4145.72,
    y1: 4722.54,
    x2: 4145.72,
    y2: 4906.01,
    gradientTransform: "translate(-2750.8 -4269.32)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 1510.63,
    y1: 504.7,
    x2: 1510.63,
    y2: 536.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#909295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#77797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#656769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5b5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 782.22,
    y1: 510.83,
    x2: 782.22,
    y2: 490.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    y1: 491.95,
    y2: 414.05,
    xlinkHref: "#linear-gradient-161"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 262.38,
    y1: 506.9,
    x2: 262.38,
    y2: 611.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 262.38,
    y1: 507.92,
    x2: 262.38,
    y2: 608.82,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    y1: 588.05,
    y2: 528.37,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 262.38,
    y1: 542.05,
    x2: 262.38,
    y2: 576.53,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 262.38,
    y1: 569.23,
    x2: 262.38,
    y2: 548.05,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 396.27,
    y1: 240.42,
    x2: 379.88,
    y2: 240.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 484.56,
    y1: 409.18,
    x2: 484.56,
    y2: 528.98,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1304.86,
    y1: 409.2,
    x2: 1304.86,
    y2: 525.82,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1459.33,
    y1: 409.2,
    x2: 1459.33,
    y2: 525.82,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 817.48,
    y1: 409.2,
    x2: 817.48,
    y2: 525.82,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 971.94,
    y1: 409.2,
    x2: 971.94,
    y2: 525.82,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 1155.62,
    y1: 507.73,
    x2: 1155.62,
    y2: 608.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 1155.62,
    y1: 572,
    x2: 1155.62,
    y2: 545.38,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 415.35,
    y1: 503.25,
    x2: 415.35,
    y2: 421.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 242.55,
    y1: 5159.78,
    x2: 242.55,
    y2: 5078.21,
    gradientTransform: "translate(674.19 5606.99) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 102.36,
    y1: 5212.74,
    x2: 102.36,
    y2: 5280.58,
    gradientTransform: "translate(-4231.35 2879.4) rotate(-116.18)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 102.36,
    y1: 5272.8,
    x2: 102.36,
    y2: 5219.72,
    gradientTransform: "translate(-4730.35 1414.77) rotate(-99.22)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 102.36,
    y1: 5225.47,
    x2: 102.36,
    y2: 5267.45,
    gradientTransform: "translate(-4730.35 1414.77) rotate(-99.22)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 102.36,
    y1: 5262.63,
    x2: 102.36,
    y2: 5229.79,
    gradientTransform: "translate(-1038.86 5510.26) rotate(-162.61)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 608.54,
    y1: 450.61,
    x2: 608.54,
    y2: 562.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#454446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#444345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#353334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#242021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 533.09,
    y1: 548.93,
    x2: 533.09,
    y2: 569.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 608.54,
    x2: 608.54,
    xlinkHref: "#linear-gradient-182"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 683.98,
    x2: 683.98,
    xlinkHref: "#linear-gradient-182"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 541.62,
    y1: 456.6,
    x2: 566.02,
    y2: 456.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 553.82,
    y1: 456.86,
    x2: 553.82,
    y2: 439.84,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 157.57,
    y1: 307.67,
    x2: 157.57,
    y2: 195.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 304.78,
    y1: 307.67,
    x2: 304.78,
    y2: 195.83,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 2959.53,
    y: 424.38,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 2959.53,
    y: -9717.48,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 2959.53,
    y: -9717.48,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 2968.53,
    y1: 479.23,
    x2: 2968.53,
    y2: 424.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 2959.53,
    y: 424.38,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-274"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "2966.68 479.23 2959.53 479.23 2959.53 424.38 2977.54 424.38 2966.68 479.23"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 2968.53,
    y1: 479.23,
    x2: 2968.53,
    y2: 424.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#767474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 2746.78,
    y: 424.38,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 2746.78,
    y: -9717.48,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 2746.78,
    y: -9717.48,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 595.96,
    x2: 595.96,
    gradientTransform: "translate(3351.75) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-188"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 2746.78,
    y: 424.38,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "2757.64 479.23 2764.8 479.23 2764.8 424.38 2746.78 424.38 2757.64 479.23"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 595.96,
    x2: 595.96,
    gradientTransform: "translate(3351.75) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-189"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 198.5,
    y1: 151.79,
    x2: 198.5,
    y2: 458.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 32.38,
    y1: 458.65,
    x2: 32.38,
    y2: 566.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 110.22,
    y1: 498.33,
    x2: 110.22,
    y2: 463.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 96.73,
    y1: 557.69,
    x2: 96.73,
    y2: 565.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 1499.08,
    y1: 453.09,
    x2: 1499.08,
    y2: 499.95,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-14",
    x1: 1509.94,
    y1: 538.42,
    x2: 1509.94,
    y2: 555.42,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-15",
    x1: 1498.46,
    y1: 431.98,
    x2: 1498.46,
    y2: 572.34,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 2271.37,
    x2: 2271.37,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 1520.03,
    x2: 1520.03,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 1037.15,
    y1: 432.9,
    x2: 1037.15,
    y2: 518.92,
    gradientTransform: "translate(-96.31 581.61) rotate(-30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#969799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bdbebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#eaebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 1274.09,
    x2: 1274.09,
    gradientTransform: "translate(2142.23 1515.05) rotate(-150)",
    xlinkHref: "#linear-gradient-197"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 984.25,
    y1: 10.79,
    x2: 984.25,
    y2: 510.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 2468.66,
    y1: 10.79,
    x2: 2468.66,
    y2: 510.36,
    xlinkHref: "#linear-gradient-199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -820.1,
    y1: 433.25,
    x2: -820.1,
    y2: 418.31,
    gradientTransform: "translate(2741.62 851.21) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -839.28,
    y1: 418.17,
    x2: -839.28,
    y2: 433.91,
    gradientTransform: "translate(2779.97 851.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -1357.66,
    x2: -1357.66,
    gradientTransform: "translate(3816.73 851.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -1376.83,
    y1: 418.17,
    x2: -1376.83,
    y2: 433.91,
    gradientTransform: "translate(3855.08 851.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -1895.22,
    x2: -1895.22,
    gradientTransform: "translate(4891.85 851.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -1914.39,
    y1: 418.17,
    x2: -1914.39,
    y2: 433.91,
    gradientTransform: "translate(4930.2 851.21) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 228.59,
    y1: 370.03,
    x2: 228.59,
    y2: 353.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 209.05,
    y1: 358.43,
    x2: 209.05,
    y2: 365.57,
    xlinkHref: "#linear-gradient-193"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 246.63,
    y1: 358.43,
    x2: 246.63,
    y2: 365.57,
    xlinkHref: "#linear-gradient-193"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 227.84,
    y1: 359.39,
    x2: 227.84,
    y2: 364.53,
    xlinkHref: "#linear-gradient-186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 84.75,
    y1: 438.48,
    x2: 84.75,
    y2: 449.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 7.62,
    y1: 294.9,
    x2: 18.41,
    y2: 326.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: -281.99,
    y1: 459,
    x2: -281.99,
    y2: 439.49,
    gradientTransform: "translate(1665.39 898.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -307.02,
    y1: 439.31,
    x2: -307.02,
    y2: 459.86,
    gradientTransform: "translate(1715.45 898.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 296.45,
    y1: 459,
    x2: 296.45,
    y2: 439.49,
    gradientTransform: "translate(508.51 898.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 271.42,
    y1: 439.31,
    x2: 271.42,
    y2: 459.86,
    gradientTransform: "translate(558.57 898.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 12.87,
    y1: 199.21,
    x2: 12.87,
    y2: 290.47,
    xlinkHref: "#linear-gradient-212"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-267",
    width: 1550,
    height: 88,
    transform: "translate(-.99 650.52)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-267",
    width: 1176,
    height: 88,
    transform: "translate(1858.01 650.52)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 1532.82,
    y: 494.31,
    width: 4.33,
    height: 32.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1763.66,517.88h-83.13c-14.42,0-25.79-9.14-40.18-20.7-25.51-20.51-60.45-48.59-139.14-48.59v-4c80.09,0,115.66,28.59,141.64,49.47,13.78,11.07,24.66,19.82,37.68,19.82h83.13c20.8,0,34.75-3.95,42.64-12.09,9.74-10.05,9.28-25.19,8.79-41.21-.69-22.34-1.4-45.44,27.36-53.99,13.29-3.95,22.27,2.58,30.19,8.34,5.89,4.29,11.46,8.34,18.41,8.34h35.15v4h-35.15c-8.25,0-14.61-4.63-20.76-9.1-7.87-5.73-15.3-11.13-26.7-7.75-25.8,7.67-25.17,28.25-24.5,50.04.5,16.15,1.01,32.86-9.91,44.12-8.68,8.95-23.56,13.3-45.51,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1778.1,518.75h-97.56c-14.33,0-25.67-8.17-40.03-18.52-25.54-18.4-60.51-43.61-139.28-43.61v-3.78c80,0,115.54,25.62,141.49,44.32,13.81,9.95,24.71,17.81,37.82,17.81h97.56c21.47,0,34.16-3.15,38.79-9.64,4.62-6.48,1.3-16.14-2.55-27.33-6.7-19.46-15.04-43.69,21.43-58.26,14.41-5.76,23.27-2.3,32.64,1.36,6.5,2.54,13.22,5.17,22.64,5.17h35.15v3.78h-35.15c-10.13,0-17.51-2.88-24.02-5.43-9.03-3.53-16.83-6.58-29.86-1.37-33.12,13.23-26.07,33.71-19.25,53.51,4.02,11.67,7.81,22.68,2.05,30.75-5.46,7.66-18.77,11.22-41.87,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1910.78,527.77h-319.4v-23.76h319.4c6.56,0,11.88,5.32,11.88,11.88h0c0,6.56-5.32,11.88-11.88,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1611.52,537.88h-22.58c-10.81,0-14.63-9.85-14.63-21.99h0c0-12.15,3.82-21.99,14.63-21.99h22.58c10.81,0,42.16,9.85,42.16,21.99h0c0,12.15-31.34,21.99-42.16,21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1636.93,519.89h-104.33c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4h104.33v8.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 1592.63,
    y: 524.16,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 1592.63,
    y: 504.01,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1618.25,513.12c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 1618.25,
    cy: 515.89,
    r: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1628,513.12c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1628,513.73c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1579,513.12c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 1579,
    cy: 515.89,
    r: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1588.74,513.12c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 1588.74,
    cy: 515.89,
    r: 2.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1592.63,
    y: 493.89,
    width: 7.99,
    height: 43.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1723.84,498.84c0-3.66-2.96-6.62-6.62-6.62s-6.62,2.96-6.62,6.62v21.31h13.24v-21.31ZM1714.22,498.22c0-1.65,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1647.51,
    y: 504.01,
    width: 240.36,
    height: 23.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 1647.51,
    y: 507.75,
    width: 240.36,
    height: 16.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1875.11,456.79l-156.87,42.53c-.74.2-1.51-.24-1.71-.98h0c-.2-.74.24-1.51.98-1.71l156.87-42.53c.74-.2,1.51.24,1.71.98h0c.2.74-.24,1.51-.98,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1754.52,494.08h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1753.81,492.42h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1753.47,490.19h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1756.87,493.44h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1756.15,491.78h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1755.81,489.55h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1759.21,492.81h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1758.49,491.15h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1758.15,488.92h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1761.55,492.17h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1760.83,490.51h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1760.49,488.28h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1763.89,491.54h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1763.17,489.88h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1762.83,487.65h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1766.23,490.9h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1765.51,489.24h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1765.17,487.01h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1768.57,490.27h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1767.85,488.61h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1767.52,486.38h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1770.91,489.63h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1770.19,487.98h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1769.86,485.75h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1773.25,489h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1772.53,487.34h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1772.2,485.11h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1775.59,488.36h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1774.87,486.71h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1774.54,484.48h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1777.93,487.73h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1777.21,486.07h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1776.88,483.84h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1780.27,487.1h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1779.55,485.44h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1779.22,483.21h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1782.61,486.46h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1781.9,484.8h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1781.56,482.57h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1784.96,485.83h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1784.24,484.17h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1783.9,481.94h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1787.3,485.19h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1786.58,483.53h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1786.24,481.3h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1789.64,484.56h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1788.92,482.9h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1788.58,480.67h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1791.98,483.92h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1791.26,482.26h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1790.92,480.03h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1794.32,483.29h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1793.6,481.63h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1793.26,479.4h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1796.66,482.65h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1795.94,480.99h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1795.61,478.76h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1799,482.02h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1798.28,480.36h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1797.95,478.13h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1801.34,481.38h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1800.62,479.73h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1800.29,477.5h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1803.68,480.75h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1802.96,479.09h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1802.63,476.86h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1806.02,480.11h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1805.3,478.46h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1804.97,476.23h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1808.36,479.48h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1807.64,477.82h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1807.31,475.59h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1810.7,478.85h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1809.99,477.19h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1809.65,474.96h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1813.05,478.21h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1812.33,476.55h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1811.99,474.32h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1815.39,477.58h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1814.67,475.92h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1814.33,473.69h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1817.73,476.94h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1817.01,475.28h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1816.67,473.05h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1820.07,476.31h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1819.35,474.65h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1819.01,472.42h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1822.41,475.67h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1821.69,474.01h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1821.35,471.78h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1824.75,475.04h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1824.03,473.38h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1823.7,471.15h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1827.09,474.4h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1826.37,472.74h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1826.04,470.52h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1829.43,473.77h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1828.71,472.11h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1828.38,469.88h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1831.77,473.13h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1831.05,471.48h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1830.72,469.25h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1834.11,472.5h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1833.39,470.84h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1833.06,468.61h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1836.45,471.86h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1835.73,470.21h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1835.4,467.98h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1838.79,471.23h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1838.08,469.57h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1837.74,467.34h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1841.13,470.6h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1840.42,468.94h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1840.08,466.71h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 1647.51,
    y: 507.61,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1776.22,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1812.78,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1849.33,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1666.57,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1703.12,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1739.67,
    y: 507.61,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1647.51,
    y: 507.61,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M1528.08,526.22h7.54c1.52,0,2.75,1.23,2.75,2.75v12.99h-13.04v-12.99c0-1.52,1.23-2.75,2.75-2.75Z",
    transform: "translate(3063.7 1068.18) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M1543.16,492.19h-9.98c-.74,0-1.33-.6-1.33-1.33s.6-1.33,1.33-1.33h9.98c2.92,0,5.73-.89,8.12-2.57l22.18-15.61c.6-.43,1.43-.28,1.86.32.42.6.28,1.43-.32,1.86l-22.18,15.61c-2.84,2-6.18,3.06-9.65,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M1540.68,535.78h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M1540.68,532.4h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1524.6,480.57h11.94c2.41,0,4.36,1.95,4.36,4.36v20.57h-20.65v-20.57c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1538.69,530.45h-17.76c-1.22,0-2.21-.99-2.21-2.21h0c0-1.22.99-2.21,2.21-2.21h17.76c1.22,0,2.21.99,2.21,2.21h0c0,1.22-.99,2.21-2.21,2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "1527.91 524.63 1527.91 505.82 1540.89 505.82 1540.89 502.88 1495.01 502.88 1495.01 527.95 1538.67 527.95 1538.67 524.63 1527.91 524.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1564.18,533.47l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02h0c0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1564.18,533.47l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-.62.24-1.26.45-1.89.64v25.24l17.87,6.98c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M1575.31,471.68c-.42-.6-1.25-.75-1.86-.32l-22.18,15.61c-2.39,1.68-5.2,2.57-8.12,2.57h-2.27v-4.6c0-2.41-1.95-4.36-4.36-4.36h-11.94c-2.41,0-4.36,1.95-4.36,4.36v17.96h-25.23v25.06h23.76c-.01.1-.06.19-.06.29,0,.28.06.55.16.8-.9.03-1.63.76-1.63,1.68s.76,1.69,1.69,1.69c-.93,0-1.69.76-1.69,1.69s.76,1.69,1.69,1.69h6.4v3.43c0,1.52,1.23,2.75,2.75,2.75h7.54c1.52,0,2.75-1.23,2.75-2.75v-3.43h2.31c.93,0,1.69-.76,1.69-1.69s-.76-1.69-1.69-1.69c.93,0,1.69-.76,1.69-1.69s-.73-1.65-1.63-1.68c.1-.25.16-.52.16-.8,0-1.22-.99-2.21-2.21-2.21h-.01v-1.4h-10.76v-18.81h12.98v-13.63h2.27c3.47,0,6.81-1.06,9.65-3.06l22.18-15.61c.6-.42.75-1.25.32-1.86ZM1559.03,506.63c.41-1.32,1.4-2.41,2.74-2.93l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02,0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92l-2.82-1.1c-.16-.06-.29-.17-.44-.25-1.26-.69-2.09-1.99-2.09-3.46v-20.64c0-.48.07-.94.21-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1506.29,531.25h0c-1.1,0-2-.89-2-2v-27.67c0-1.1.89-2,2-2h0c1.1,0,2,.89,2,2v27.67c0,1.1-.89,2-2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1901.71,
    y: 530.67,
    width: 39.48,
    height: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1891.67,521.52c-2.44,2.61-2.3,6.72.31,9.16l8.71,8.13c2.61,2.44,6.72,2.3,9.16-.31,2.44-2.61,2.3-6.72-.31-9.16l-8.71-8.13c-2.61-2.44-6.72-2.3-9.16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1909.29,537.98h0c-2.16,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.15-2.43-5.77-.28-8.08h0c2.15-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1898.77,523.63c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16-1.33-1.24-1.41-3.34-.16-4.67s3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1898.27,524.16c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.12-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1907.26,531.56c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16s-1.41-3.34-.16-4.67c1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1906.77,532.09c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.13-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1909.29,537.98h0c-2.16,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.15-2.43-5.77-.28-8.08h0c2.15-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.16,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2186.47,529.04l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1946.28,
    y: 411.85,
    width: 215.96,
    height: 75.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1883.86,479.23v5.12l20.43,18.32v17.28l23.52,22.8h12.88l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h209.96l24.45-21.05v-29.01h-305.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M1887.64,476.22v5.12l20.43,18.32v17.28l23.52,22.8h6.42l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h208.68l24.45-21.05v-29.01h-297.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 1919.13,
    cy: 515.89,
    r: 4.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1919.13,512.03c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 1936.5,
    cy: 515.89,
    r: 4.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1936.5,512.03c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1876.52,448.42c-3.66,0-6.62,2.96-6.62,6.62s2.96,6.62,6.62,6.62h21.31v-13.24h-21.31ZM1875.9,458.03c-1.66,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1883.86,
    y: 442.6,
    width: 305.03,
    height: 41.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1883.86,
    y: 448.15,
    width: 305.03,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 1912.89,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 1887.64,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 1920.86,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 2147.69,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 2155.66,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 2180.76,
    y: 448.15,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 2061.91,
    cy: 558.47,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2061.66,467.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2061.66,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2153.96,561.18v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2061.66,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2061.66,476.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2061.66,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M2061.66,500.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2061.66,608.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M2061.66,506.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2061.66,606.57c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2061.63,507.98c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2028.87,525.91c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2020.82,568.9c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2040.13,594.71c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2061.5,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2061.76,604.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2083.13,522.28c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2094.4,591.08c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2102.44,568.64c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M2111.67,551.9c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2036.5,533.55c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2061.5,523.09c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2097.67,536.82c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M2026.46,537.65c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2061.5,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M2061.63,507.98c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2028.87,525.91c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2020.82,568.9c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2040.13,594.71c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM2061.5,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2061.76,604.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.28,2.42,10.28,5.4-4.6,5.4-10.28,5.4ZM2083.13,522.28c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2094.4,591.08c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2102.44,568.64c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2064.14 579.59 2059.97 579.59 2057.88 583.2 2059.97 586.81 2064.14 586.81 2066.23 583.2 2064.14 579.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2064.1,583.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2078.35 571.65 2075.4 574.6 2076.48 578.63 2080.51 579.71 2083.46 576.76 2082.38 572.73 2078.35 571.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2080.88,574.23c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2082.78 555.99 2082.78 560.16 2086.4 562.25 2090.01 560.16 2090.01 555.99 2086.4 553.91 2082.78 555.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2086.4,556.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2074.85 541.78 2077.8 544.73 2081.83 543.65 2082.91 539.62 2079.96 536.67 2075.93 537.75 2074.85 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2077.43,539.26c.8-.8,2.09-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2059.19 537.35 2063.36 537.35 2065.45 533.73 2063.36 530.12 2059.19 530.12 2057.1 533.73 2059.19 537.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2059.23,533.73c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2044.98 545.28 2047.93 542.33 2046.85 538.3 2042.82 537.22 2039.87 540.17 2040.95 544.2 2044.98 545.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2042.45,542.7c-.8-.8-.8-2.1,0-2.89s2.09-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2040.54 560.94 2040.54 556.77 2036.93 554.68 2033.32 556.77 2033.32 560.94 2036.93 563.03 2040.54 560.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2036.93,560.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2048.48 575.15 2045.53 572.2 2041.5 573.28 2040.42 577.31 2043.37 580.26 2047.4 579.18 2048.48 575.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2045.9,577.68c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89s2.09-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-158",
    cx: 2061.66,
    cy: 558.47,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-165",
    cx: 2061.66,
    cy: 558.47,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M2171.45,520.01c-3.27,1.44-4.77,5.27-3.33,8.54l4.79,10.91c1.44,3.27,5.27,4.77,8.54,3.33,3.27-1.44,4.77-5.27,3.33-8.54l-4.79-10.91c-1.44-3.27-5.27-4.77-8.54-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2181.14,542.09h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2177.14,524.75c.73,1.67-.03,3.62-1.7,4.35s-3.62-.03-4.35-1.7c-.73-1.67.03-3.62,1.7-4.35,1.67-.73,3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2176.47,525.04c.57,1.3-.02,2.82-1.32,3.4s-2.82-.02-3.4-1.32c-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2181.81,535.39c.73,1.67-.03,3.62-1.7,4.35-1.67.73-3.62-.03-4.35-1.7-.73-1.67.03-3.62,1.7-4.35s3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2181.15,535.69c.57,1.3-.02,2.82-1.32,3.4-1.3.57-2.82-.02-3.4-1.32-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M2181.14,542.09h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1951.15,519.73c-3.35-1.23-7.09.49-8.32,3.85l-4.11,11.18c-1.23,3.35.49,7.09,3.85,8.32,3.35,1.23,7.09-.49,8.32-3.85l4.11-11.18c1.23-3.35-.49-7.09-3.85-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1942.82,542.36h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1951.96,527.08c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24.63-1.71,2.53-2.59,4.24-1.96,1.71.63,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1951.28,526.83c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53s2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1947.95,538c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24s2.53-2.59,4.24-1.96,2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1947.27,537.74c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M1942.82,542.36h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M2394.69,477.96l-6.29,4.47v49.81l6.29,4.47c2.35,1.67,5.28,2.59,8.3,2.59h155.42c3.01,0,5.94-.91,8.3-2.59l6.29-4.47h0v-49.81h0l-6.29-4.47c-2.35-1.67-5.28-2.59-8.3-2.59h-155.42c-3.02,0-5.94.91-8.3,2.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2455.79,
    y: 415.04,
    width: 49.81,
    height: 184.59,
    transform: "translate(1973.36 2988.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2569.35,
    y: 484.77,
    width: 5.98,
    height: 1.31,
    transform: "translate(3057.76 -2086.92) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 2566.78,
    y: 484.57,
    width: 5.98,
    height: 1.71,
    transform: "translate(3055.19 -2084.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 2563.6,
    y: 484.44,
    width: 5.98,
    height: 1.96,
    transform: "translate(3052.01 -2081.16) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2559.77,
    y: 484.23,
    width: 5.98,
    height: 2.38,
    transform: "translate(3048.18 -2077.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2555.27,
    y: 484.03,
    width: 5.98,
    height: 2.79,
    transform: "translate(3043.68 -2072.84) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 2550.23,
    y: 483.9,
    width: 5.98,
    height: 3.05,
    transform: "translate(3038.64 -2067.8) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 2544.64,
    y: 483.69,
    width: 5.98,
    height: 3.46,
    transform: "translate(3033.05 -2062.21) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 2538.59,
    y: 483.59,
    width: 5.98,
    height: 3.67,
    transform: "translate(3027 -2056.16) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 2531.92,
    y: 483.48,
    width: 5.98,
    height: 3.88,
    transform: "translate(3020.33 -2049.49) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 2524.99,
    y: 483.33,
    width: 5.98,
    height: 4.19,
    transform: "translate(3013.4 -2042.56) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 2517.56,
    y: 483.25,
    width: 5.98,
    height: 4.34,
    transform: "translate(3005.97 -2035.13) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 2509.91,
    y: 483.11,
    width: 5.98,
    height: 4.63,
    transform: "translate(2998.32 -2027.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2501.89,
    y: 483.11,
    width: 5.98,
    height: 4.63,
    transform: "translate(2990.3 -2019.46) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 2493.77,
    y: 483,
    width: 5.98,
    height: 4.83,
    transform: "translate(2982.19 -2011.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2485.55,
    y: 483,
    width: 5.98,
    height: 4.83,
    transform: "translate(2973.96 -2003.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2386.07,
    y: 484.77,
    width: 5.98,
    height: 1.31,
    transform: "translate(1903.64 2874.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 2388.65,
    y: 484.57,
    width: 5.98,
    height: 1.71,
    transform: "translate(1906.21 2877.06) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 2391.83,
    y: 484.44,
    width: 5.98,
    height: 1.97,
    transform: "translate(1909.39 2880.24) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 2395.65,
    y: 484.23,
    width: 5.98,
    height: 2.38,
    transform: "translate(1913.22 2884.06) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 2400.15,
    y: 484.03,
    width: 5.98,
    height: 2.79,
    transform: "translate(1917.72 2888.56) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 2405.19,
    y: 483.9,
    width: 5.98,
    height: 3.05,
    transform: "translate(1922.76 2893.6) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2410.78,
    y: 483.69,
    width: 5.98,
    height: 3.46,
    transform: "translate(1928.34 2899.19) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2416.83,
    y: 483.59,
    width: 5.98,
    height: 3.67,
    transform: "translate(1934.39 2905.24) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 2423.5,
    y: 483.48,
    width: 5.98,
    height: 3.88,
    transform: "translate(1941.07 2911.91) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 2430.43,
    y: 483.33,
    width: 5.98,
    height: 4.19,
    transform: "translate(1947.99 2918.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 2437.86,
    y: 483.25,
    width: 5.98,
    height: 4.34,
    transform: "translate(1955.43 2926.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 2445.51,
    y: 483.11,
    width: 5.98,
    height: 4.63,
    transform: "translate(1963.08 2933.92) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 2453.53,
    y: 483.11,
    width: 5.98,
    height: 4.63,
    transform: "translate(1971.1 2941.94) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2461.65,
    y: 483,
    width: 5.98,
    height: 4.83,
    transform: "translate(1979.21 2950.06) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2469.87,
    y: 483,
    width: 5.98,
    height: 4.83,
    transform: "translate(1987.44 2958.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2477.71,
    y: 483.04,
    width: 5.98,
    height: 4.76,
    transform: "translate(1995.28 2966.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 2569.35,
    y: 528.6,
    width: 5.98,
    height: 1.31,
    transform: "translate(3101.6 -2043.09) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 2566.78,
    y: 528.4,
    width: 5.98,
    height: 1.71,
    transform: "translate(3099.02 -2040.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 2563.6,
    y: 528.27,
    width: 5.98,
    height: 1.96,
    transform: "translate(3095.84 -2037.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 2559.77,
    y: 528.07,
    width: 5.98,
    height: 2.38,
    transform: "translate(3092.01 -2033.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 2555.27,
    y: 527.86,
    width: 5.98,
    height: 2.79,
    transform: "translate(3087.52 -2029) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2550.23,
    y: 527.73,
    width: 5.98,
    height: 3.05,
    transform: "translate(3082.47 -2023.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2544.64,
    y: 527.52,
    width: 5.98,
    height: 3.46,
    transform: "translate(3076.89 -2018.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 2538.59,
    y: 527.42,
    width: 5.98,
    height: 3.67,
    transform: "translate(3070.84 -2012.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 2531.92,
    y: 527.32,
    width: 5.98,
    height: 3.88,
    transform: "translate(3064.17 -2005.66) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 2524.99,
    y: 527.16,
    width: 5.98,
    height: 4.19,
    transform: "translate(3057.24 -1998.73) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 2517.56,
    y: 527.08,
    width: 5.98,
    height: 4.34,
    transform: "translate(3049.81 -1991.29) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 2509.91,
    y: 526.94,
    width: 5.98,
    height: 4.63,
    transform: "translate(3042.15 -1983.64) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 2501.89,
    y: 526.94,
    width: 5.98,
    height: 4.63,
    transform: "translate(3034.14 -1975.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 2493.77,
    y: 526.84,
    width: 5.98,
    height: 4.83,
    transform: "translate(3026.02 -1967.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 2485.55,
    y: 526.84,
    width: 5.98,
    height: 4.83,
    transform: "translate(3017.8 -1959.29) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 2386.07,
    y: 528.6,
    width: 5.98,
    height: 1.31,
    transform: "translate(1859.8 2918.31) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2388.65,
    y: 528.4,
    width: 5.98,
    height: 1.71,
    transform: "translate(1862.38 2920.89) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 2391.83,
    y: 528.27,
    width: 5.98,
    height: 1.97,
    transform: "translate(1865.56 2924.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 2395.65,
    y: 528.07,
    width: 5.98,
    height: 2.38,
    transform: "translate(1869.38 2927.9) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 2400.15,
    y: 527.86,
    width: 5.98,
    height: 2.79,
    transform: "translate(1873.88 2932.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 2405.19,
    y: 527.73,
    width: 5.98,
    height: 3.05,
    transform: "translate(1878.93 2937.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2410.78,
    y: 527.52,
    width: 5.98,
    height: 3.46,
    transform: "translate(1884.51 2943.02) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2416.83,
    y: 527.42,
    width: 5.98,
    height: 3.67,
    transform: "translate(1890.56 2949.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 2423.5,
    y: 527.32,
    width: 5.98,
    height: 3.88,
    transform: "translate(1897.23 2955.74) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 2430.43,
    y: 527.16,
    width: 5.98,
    height: 4.19,
    transform: "translate(1904.16 2962.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 2437.86,
    y: 527.08,
    width: 5.98,
    height: 4.34,
    transform: "translate(1911.59 2970.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 2445.51,
    y: 526.94,
    width: 5.98,
    height: 4.63,
    transform: "translate(1919.25 2977.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 2453.53,
    y: 526.94,
    width: 5.98,
    height: 4.63,
    transform: "translate(1927.26 2985.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 2461.65,
    y: 526.84,
    width: 5.98,
    height: 4.83,
    transform: "translate(1935.38 2993.89) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 2469.87,
    y: 526.84,
    width: 5.98,
    height: 4.83,
    transform: "translate(1943.6 3002.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 2477.71,
    y: 526.88,
    width: 5.98,
    height: 4.76,
    transform: "translate(1951.44 3009.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 2460.72,
    y: 415.04,
    width: 39.96,
    height: 184.59,
    transform: "translate(1973.36 2988.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2388.79,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2394.26,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2399.73,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2405.19,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2412.24,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2419.29,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2426.34,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2433.38,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2440.43,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2448.64,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2456.86,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2465.07,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2473.28,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2566.74,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2561.27,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2555.81,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2550.34,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2543.29,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2536.24,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2529.2,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2522.15,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2515.1,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2506.89,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2498.68,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2490.46,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2482.25,515.13c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2572.6,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2567.14,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2561.67,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2556.21,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2549.16,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2542.11,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2535.06,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2528.02,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2520.97,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2512.76,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2504.54,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2496.33,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2488.12,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2394.66,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2400.13,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2405.59,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2411.06,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2418.11,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2425.15,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2432.2,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2439.25,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2446.3,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2454.51,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2462.72,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2470.94,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2479.15,499.55c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2479.94,
    y: 415.04,
    width: 1.52,
    height: 184.59,
    transform: "translate(1973.36 2988.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2479.94,
    y: 432.79,
    width: 1.52,
    height: 184.59,
    transform: "translate(1955.61 3005.78) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2479.94,
    y: 397.3,
    width: 1.52,
    height: 184.59,
    transform: "translate(1991.11 2970.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 2388.4,
    y: 475.37,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "2719.86 479.23 2719.86 519.95 2743.38 542.75 2768.94 542.75 2778.93 529.28 2945.4 529.28 2955.39 542.75 2980.94 542.75 3004.46 519.95 3004.46 479.23 2719.86 479.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2986.97,529.04l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "3033.03 484.35 2322.41 484.35 2216.49 432.16 1904.29 432.16 1904.29 411.85 3033.03 411.85 3033.03 484.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2347.93,
    y: 428.83,
    width: 685.09,
    height: 55.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 2347.93,
    y: 436.21,
    width: 685.09,
    height: 40.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2995.23,452.82h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 3007.29,
    y: 538.32,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 3001.65,
    y: 417.85,
    width: 11.28,
    height: 156.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M3030.41,478.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.72,5.71-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3031.05,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3031.16,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3029.34,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3029.45,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3027.63,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3027.74,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M3030.41,456.09h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 3031.05,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 3031.16,
    y: 457.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 3029.34,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M3029.8,457.81h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 3027.63,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 3027.74,
    y: 457.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 2862.41,
    cy: 558.47,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2862.16,467.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2862.16,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2954.46,561.18v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2862.16,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2862.16,476.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2862.16,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M2862.16,500.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2862.16,608.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M2862.16,506.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2862.16,606.57c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M2862.13,507.98c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2829.36,525.91c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2821.32,568.9c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2840.63,594.71c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM2862,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2862.26,604.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2883.63,522.28c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2894.9,591.08c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2902.94,568.64c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M2912.17,551.9c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2837,533.55c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2862,523.09c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2898.16,536.82c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M2826.96,537.65c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2862,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M2862.13,507.98c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2829.36,525.91c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2821.32,568.9c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.27-5.4,10.27ZM2840.63,594.71c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45s5.56,8.98,3.45,11.09ZM2862,512.29c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM2862.26,604.71c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2883.63,522.28c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2894.9,591.08c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2902.94,568.64c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2864.64 579.59 2860.46 579.59 2858.38 583.2 2860.46 586.81 2864.64 586.81 2866.72 583.2 2864.64 579.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2864.6,583.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2878.84 571.65 2875.89 574.6 2876.97 578.63 2881 579.71 2883.95 576.76 2882.87 572.73 2878.84 571.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2881.37,574.23c.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2883.28 555.99 2883.28 560.16 2886.89 562.25 2890.51 560.16 2890.51 555.99 2886.89 553.91 2883.28 555.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2886.89,556.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2875.35 541.78 2878.3 544.73 2882.33 543.65 2883.41 539.62 2880.46 536.67 2876.43 537.75 2875.35 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2877.93,539.26c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2859.69 537.35 2863.86 537.35 2865.94 533.73 2863.86 530.12 2859.69 530.12 2857.6 533.73 2859.69 537.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2859.73,533.73c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2845.48 545.28 2848.43 542.33 2847.35 538.3 2843.32 537.22 2840.37 540.17 2841.45 544.2 2845.48 545.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2842.95,542.7c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2841.04 560.94 2841.04 556.77 2837.43 554.68 2833.81 556.77 2833.81 560.94 2837.43 563.03 2841.04 560.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2837.43,560.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "2848.98 575.15 2846.03 572.2 2842 573.28 2840.92 577.31 2843.87 580.26 2847.9 579.18 2848.98 575.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M2846.39,577.68c-.8.8-2.09.8-2.89,0s-.8-2.09,0-2.89c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-224",
    cx: 2862.16,
    cy: 558.47,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-225",
    cx: 2862.16,
    cy: 558.47,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M676.13,518.94c-66.22,0-92.91,9.07-112.4,15.7-10.84,3.68-18.68,6.34-30.09,6.34h-166.1c-18.02,0-45.37-41.1-58.37-67.01-1.55-3.08-5.3-4.33-8.38-2.78-3.08,1.55-4.33,5.3-2.78,8.38,3.79,7.56,37.98,73.9,69.54,73.9h166.1c13.48,0,23.04-3.25,34.11-7.01,18.66-6.34,44.23-15.03,108.38-15.03h827.97v-12.5h-827.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 777.99,
    y: 507.92,
    width: 181.17,
    height: 31.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M1308.91,515.12l-6.29,4.39v48.83l6.29,4.39c2.35,1.64,5.28,2.54,8.3,2.54h155.42c3.01,0,5.94-.89,8.3-2.54l6.29-4.39h0v-48.83h0l-6.29-4.39c-2.35-1.64-5.28-2.54-8.3-2.54h-155.42c-3.02,0-5.94.89-8.3,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1370.5,
    y: 451.63,
    width: 48.83,
    height: 184.59,
    transform: "translate(850.99 1938.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 1483.63,
    y: 521.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(2009 -964.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 1481.05,
    y: 521.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(2006.42 -961.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 1477.87,
    y: 521.46,
    width: 5.86,
    height: 1.96,
    transform: "translate(2003.24 -958.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1474.04,
    y: 521.25,
    width: 5.86,
    height: 2.38,
    transform: "translate(1999.41 -954.53) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1469.54,
    y: 521.04,
    width: 5.86,
    height: 2.79,
    transform: "translate(1994.91 -950.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1464.5,
    y: 520.91,
    width: 5.86,
    height: 3.05,
    transform: "translate(1989.87 -944.99) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1458.92,
    y: 520.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(1984.29 -939.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1452.87,
    y: 520.6,
    width: 5.86,
    height: 3.67,
    transform: "translate(1978.24 -933.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1446.2,
    y: 520.5,
    width: 5.86,
    height: 3.88,
    transform: "translate(1971.57 -926.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1439.27,
    y: 520.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(1964.64 -919.76) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1431.84,
    y: 520.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(1957.2 -912.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1424.18,
    y: 520.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1949.55 -904.67) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1416.17,
    y: 520.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1941.54 -896.66) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1408.05,
    y: 520.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(1933.42 -888.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1399.83,
    y: 520.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(1925.2 -880.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1300.34,
    y: 521.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(780.83 1825.71) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1302.92,
    y: 521.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(783.41 1828.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1306.1,
    y: 521.46,
    width: 5.86,
    height: 1.96,
    transform: "translate(786.59 1831.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1309.93,
    y: 521.25,
    width: 5.86,
    height: 2.38,
    transform: "translate(790.42 1835.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1314.42,
    y: 521.04,
    width: 5.86,
    height: 2.79,
    transform: "translate(794.91 1839.79) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1319.47,
    y: 520.91,
    width: 5.86,
    height: 3.05,
    transform: "translate(799.96 1844.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1325.05,
    y: 520.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(805.54 1850.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1331.1,
    y: 520.6,
    width: 5.86,
    height: 3.67,
    transform: "translate(811.59 1856.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1337.77,
    y: 520.5,
    width: 5.86,
    height: 3.88,
    transform: "translate(818.26 1863.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1344.7,
    y: 520.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(825.19 1870.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1352.13,
    y: 520.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(832.62 1877.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1359.79,
    y: 520.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(840.28 1885.16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1367.8,
    y: 520.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(848.29 1893.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1375.92,
    y: 520.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(856.41 1901.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1384.14,
    y: 520.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(864.63 1909.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1391.98,
    y: 520.06,
    width: 5.86,
    height: 4.76,
    transform: "translate(872.47 1917.35) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1483.63,
    y: 564.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(2051.96 -921.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1481.05,
    y: 564.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(2049.39 -918.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1477.87,
    y: 564.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(2046.21 -915.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1474.04,
    y: 564.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(2042.38 -911.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1469.54,
    y: 564.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(2037.88 -907.07) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1464.5,
    y: 563.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(2032.84 -902.02) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1458.92,
    y: 563.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(2027.26 -896.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1452.87,
    y: 563.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(2021.21 -890.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1446.2,
    y: 563.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(2014.54 -883.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1439.27,
    y: 563.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(2007.61 -876.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1431.84,
    y: 563.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(2000.17 -869.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1424.18,
    y: 563.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(1992.52 -861.7) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1416.17,
    y: 563.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(1984.5 -853.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1408.05,
    y: 562.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(1976.39 -845.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1399.83,
    y: 562.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(1968.16 -837.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1300.34,
    y: 564.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(737.86 1868.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1302.92,
    y: 564.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(740.44 1871.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1306.1,
    y: 564.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(743.62 1874.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1309.93,
    y: 564.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(747.45 1878.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1314.42,
    y: 564.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(751.95 1882.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1319.47,
    y: 563.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(756.99 1887.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1325.05,
    y: 563.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(762.57 1893.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1331.1,
    y: 563.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(768.62 1899.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1337.77,
    y: 563.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(775.29 1906.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1344.7,
    y: 563.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(782.22 1913.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1352.13,
    y: 563.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(789.66 1920.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1359.79,
    y: 563.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(797.31 1928.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1367.8,
    y: 563.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(805.32 1936.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 1375.92,
    y: 562.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(813.44 1944.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1384.14,
    y: 562.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(821.66 1952.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1391.98,
    y: 563.03,
    width: 5.86,
    height: 4.76,
    transform: "translate(829.51 1960.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1375.33,
    y: 451.63,
    width: 39.17,
    height: 184.59,
    transform: "translate(850.99 1938.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1320.11,555.99l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1320.11,546.53l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1320.11,537.08l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1320.11,527.63l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 1302.62,
    y: 512.59,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M1524.2,520.54c0,7.74-1.4,14.01-3.12,14.01s-3.12-6.27-3.12-14.01,1.4-14.01,3.12-14.01,3.12,6.27,3.12,14.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1500.18,
    y: 504.17,
    width: 20.9,
    height: 32.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 507.05,
    y: 533.07,
    width: 571.32,
    height: 13.18,
    transform: "translate(44.37 -60.01) rotate(4.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M60.34,358.27h301.54c13.6,0,24.64,11.04,24.64,24.64v100.14H60.34v-124.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M318.69,545.8h-99.68c-19.41,0-38.4-3.9-54.92-11.27-12.7-5.67-27.33-8.66-42.31-8.66h-61.44v-19.3h61.44c19.4,0,38.39,3.9,54.91,11.27,12.7,5.67,27.33,8.67,42.31,8.67h99.68c12.07,0,24.18-2,35.02-5.77l19.12-6.67c14.08-4.91,29.77-7.5,45.38-7.5h1085.9v19.3H418.21c-12.07,0-24.17,2-35.02,5.78l-19.12,6.66c-14.07,4.91-29.77,7.5-45.38,7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 60.34,
    y: 448.87,
    width: 1443.76,
    height: 62.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 60.34,
    y: 409.79,
    width: 1443.76,
    height: 83.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M262.38,467.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM262.38,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M354.68,561.18v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.53-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM262.38,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M262.38,476.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM262.38,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M262.38,500.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM262.38,608.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M262.38,506.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM262.38,603.67c-24.96,0-45.2-20.24-45.2-45.2s20.24-45.2,45.2-45.2,45.2,20.24,45.2,45.2-20.24,45.2-45.2,45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M262.38,510.24c-26.63,0-48.22,21.59-48.22,48.22s21.59,48.22,48.22,48.22,48.22-21.59,48.22-48.22-21.59-48.22-48.22-48.22ZM234.25,586.26c-2,1.15-4.55.47-5.7-1.53l-7.25-12.55c-1.15-2-.47-4.55,1.53-5.7,2-1.15,4.55-.47,5.7,1.53l7.25,12.55c1.15,2,.47,4.55-1.53,5.7ZM237.19,533.93l-7.25,12.55c-1.15,2-3.7,2.68-5.7,1.53-2-1.15-2.68-3.7-1.53-5.7l7.25-12.55c1.15-2,3.7-2.68,5.7-1.53h0c2,1.15,2.68,3.7,1.53,5.7ZM268.22,600.9h-14.49c-2.3,0-4.17-1.87-4.17-4.17s1.87-4.17,4.17-4.17h14.49c2.3,0,4.17,1.87,4.17,4.17s-1.87,4.17-4.17,4.17ZM271.03,524.38h-14.49c-2.3,0-4.17-1.87-4.17-4.17s1.87-4.17,4.17-4.17h14.49c2.3,0,4.17,1.87,4.17,4.17s-1.87,4.17-4.17,4.17ZM302.04,574.63l-7.25,12.55c-1.15,2-3.7,2.68-5.7,1.53-2-1.15-2.68-3.7-1.53-5.7l7.25-12.55c1.15-2,3.7-2.68,5.7-1.53,2,1.15,2.68,3.7,1.53,5.7ZM301.92,550.45c-2,1.15-4.55.47-5.7-1.53l-7.25-12.55c-1.15-2-.47-4.55,1.53-5.7h0c2-1.15,4.55-.47,5.7,1.53l7.25,12.55c1.15,2,.47,4.55-1.53,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M262.38,507.92c-27.92,0-50.55,22.63-50.55,50.55s22.63,50.55,50.55,50.55,50.55-22.63,50.55-50.55-22.63-50.55-50.55-50.55ZM232.9,587.6c-2.09,1.21-4.77.49-5.97-1.6l-7.6-13.16c-1.21-2.09-.49-4.77,1.6-5.97,2.09-1.21,4.77-.49,5.97,1.6l7.6,13.16c1.21,2.09.49,4.77-1.6,5.97ZM235.97,532.75l-7.6,13.16c-1.21,2.09-3.88,2.81-5.97,1.6-2.09-1.21-2.81-3.88-1.6-5.97l7.6-13.16c1.21-2.09,3.88-2.81,5.97-1.6h0c2.09,1.21,2.81,3.88,1.6,5.97ZM268.5,602.94h-15.19c-2.42,0-4.37-1.96-4.37-4.37s1.96-4.37,4.37-4.37h15.19c2.42,0,4.37,1.96,4.37,4.37s-1.96,4.37-4.37,4.37ZM271.45,522.74h-15.19c-2.42,0-4.37-1.96-4.37-4.37s1.96-4.37,4.37-4.37h15.19c2.42,0,4.37,1.96,4.37,4.37s-1.96,4.37-4.37,4.37ZM303.96,575.41l-7.6,13.16c-1.21,2.09-3.88,2.81-5.97,1.6-2.09-1.21-2.81-3.88-1.6-5.97l7.6-13.16c1.21-2.09,3.88-2.81,5.97-1.6,2.09,1.21,2.81,3.88,1.6,5.97ZM303.83,550.06c-2.09,1.21-4.77.49-5.97-1.6l-7.6-13.16c-1.21-2.09-.49-4.77,1.6-5.97h0c2.09-1.21,4.77-.49,5.97,1.6l7.6,13.16c1.21,2.09.49,4.77-1.6,5.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 262.38,
    cy: 558.47,
    r: 30.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 262.38,
    cy: 558.47,
    r: 18.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "264.85 579.59 260.68 579.59 258.6 583.2 260.68 586.81 264.85 586.81 266.94 583.2 264.85 579.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M264.81,583.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "279.06 571.65 276.11 574.6 277.19 578.63 281.22 579.71 284.17 576.76 283.09 572.73 279.06 571.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M281.59,574.23c.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "283.5 555.99 283.5 560.16 287.11 562.25 290.73 560.16 290.73 555.99 287.11 553.91 283.5 555.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M287.11,556.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "275.56 541.78 278.51 544.73 282.54 543.65 283.62 539.62 280.67 536.67 276.64 537.75 275.56 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M278.15,539.26c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "259.9 537.35 264.08 537.35 266.16 533.73 264.08 530.12 259.9 530.12 257.82 533.73 259.9 537.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M259.94,533.73c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "245.7 545.28 248.65 542.33 247.57 538.3 243.54 537.22 240.59 540.17 241.67 544.2 245.7 545.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M243.17,542.7c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "241.26 560.94 241.26 556.77 237.65 554.68 234.03 556.77 234.03 560.94 237.65 563.03 241.26 560.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M237.65,560.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "249.19 575.15 246.24 572.2 242.21 573.28 241.13 577.31 244.08 580.26 248.11 579.18 249.19 575.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M246.61,577.68c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 262.38,
    cy: 558.47,
    r: 10.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1293.02,532.84l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 1155.87,
    cy: 558.47,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M386.51,415.5h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M397.65,219.98c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 478.38,
    y: 409.79,
    width: 12.36,
    height: 119.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1298.68,
    y: 409.79,
    width: 12.36,
    height: 116.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1453.15,
    y: 409.79,
    width: 12.36,
    height: 116.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 811.3,
    y: 409.79,
    width: 12.36,
    height: 116.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 965.76,
    y: 409.79,
    width: 12.36,
    height: 116.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1155.62,467.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1155.62,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1247.92,561.18v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1155.62,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M1155.62,476.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1155.62,605.56c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1155.62,500.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1155.62,608.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1155.62,506.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1155.62,603.67c-24.96,0-45.2-20.24-45.2-45.2s20.24-45.2,45.2-45.2,45.2,20.24,45.2,45.2-20.24,45.2-45.2,45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1155.62,507.92c-27.92,0-50.55,22.63-50.55,50.55s22.63,50.55,50.55,50.55,50.55-22.63,50.55-50.55-22.63-50.55-50.55-50.55ZM1182.44,526.83c2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21ZM1128.81,590.1c-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21,2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21ZM1127.17,542.04c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02,2.96,1.71,2.22,8.52-1.64,15.21ZM1155.62,603.69c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1155.62,525.61c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1194.79,581.08c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02,2.96,1.71,2.22,8.52-1.64,15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M1155.62,507.92c-26.04,0-47.46,19.69-50.23,44.99,1.93,5.33,4.69,10.26,8.11,14.65.3-.73.71-1.33,1.31-1.68,2.96-1.71,8.49,2.33,12.35,9.02,1.33,2.3,2.25,4.59,2.82,6.7,7.61,4.17,16.34,6.55,25.64,6.55s18.03-2.38,25.64-6.55c.57-2.11,1.49-4.41,2.82-6.7,3.86-6.69,9.39-10.73,12.35-9.02.6.35,1.01.95,1.31,1.68,3.42-4.39,6.18-9.32,8.11-14.65-2.77-25.3-24.19-44.99-50.23-44.99ZM1127.17,542.04c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02s2.22,8.52-1.64,15.21ZM1155.62,525.61c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1196.43,551.06c-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21,2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1158.09 579.59 1153.92 579.59 1151.84 583.2 1153.92 586.81 1158.09 586.81 1160.18 583.2 1158.09 579.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1158.06,583.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1172.3 571.65 1169.35 574.6 1170.43 578.63 1174.46 579.71 1177.41 576.76 1176.33 572.73 1172.3 571.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1174.83,574.23c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1176.74 555.99 1176.74 560.16 1180.35 562.25 1183.97 560.16 1183.97 555.99 1180.35 553.91 1176.74 555.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1180.35,556.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1168.81 541.78 1171.76 544.73 1175.78 543.65 1176.86 539.62 1173.91 536.67 1169.88 537.75 1168.81 541.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1171.39,539.26c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1153.15 537.35 1157.32 537.35 1159.4 533.73 1157.32 530.12 1153.15 530.12 1151.06 533.73 1153.15 537.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1153.19,533.73c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1138.94 545.28 1141.89 542.33 1140.81 538.3 1136.78 537.22 1133.83 540.17 1134.91 544.2 1138.94 545.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1136.41,542.7c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1134.5 560.94 1134.5 556.77 1130.89 554.68 1127.27 556.77 1127.27 560.94 1130.89 563.03 1134.5 560.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1130.89,560.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "1142.44 575.15 1139.49 572.2 1135.46 573.28 1134.38 577.31 1137.33 580.26 1141.36 579.18 1142.44 575.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1139.85,577.68c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.09,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 1155.62,
    cy: 558.47,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 1155.62,
    cy: 558.47,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M431.14,460.3h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M415.86,490.17h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 431.65,
    cy: 473.4,
    r: 34.46,
    transform: "translate(-183.61 651.96) rotate(-63.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 431.65,
    cy: 473.4,
    r: 27.78,
    transform: "translate(-104.78 823.64) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 431.65,
    cy: 473.4,
    r: 21.32,
    transform: "translate(-104.78 823.64) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 431.65,
    cy: 473.4,
    r: 17.19,
    transform: "translate(-121.77 150.67) rotate(-17.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 503.01,
    y: 449.02,
    width: 211.04,
    height: 113.52,
    rx: 4.4,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 516.2,
    y: 548.64,
    width: 33.77,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 528.09,
    y: 445.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M533.09,567.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 591.65,
    y: 548.64,
    width: 33.77,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 603.54,
    y: 445.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M608.54,567.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 667.09,
    y: 548.64,
    width: 33.77,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 678.98,
    y: 445.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M683.98,567.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M541.62,448.47h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 553.82,
    cy: 448.47,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M249.69,250.62c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M86.08,290.75c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M123.71,194.36h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 273,
    y: 194.36,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M273,279.69v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M136.22,291.33l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M2206.8,627.48c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.79v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M2189.11,469.49l-31.92-31.85c-5.06-5.04-11.91-7.88-19.05-7.88h-163.44c-2.94,0-5.33,2.39-5.33,5.33h0c0,2.94,2.39,5.33,5.33,5.33h163.44c4.32,0,8.46,1.71,11.52,4.76l31.92,31.85c3.07,3.06,4.79,7.21,4.79,11.55v22.3h10.66v-22.3c0-7.16-2.85-14.03-7.92-19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M2987.31,633.73c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "2966.68 479.23 2959.53 479.23 2959.53 424.38 2977.54 424.38 2966.68 479.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "2966.68 479.23 2959.53 479.23 2959.53 424.38 2977.54 424.38 2966.68 479.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "2757.64 479.23 2764.8 479.23 2764.8 424.38 2746.78 424.38 2757.64 479.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "2757.64 479.23 2764.8 479.23 2764.8 424.38 2746.78 424.38 2757.64 479.23"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M2977.54,517.14h-10.66v-22.3c0-4.36-1.7-8.47-4.79-11.55l-31.92-31.85c-3.08-3.07-7.17-4.76-11.52-4.76h-112.98c-4.35,0-8.44,1.69-11.52,4.76l-31.93,31.85c-3.09,3.08-4.79,7.18-4.79,11.55v22.3h-10.66v-22.3c0-7.21,2.81-13.99,7.92-19.09l31.93-31.85c5.09-5.08,11.85-7.88,19.05-7.88h112.98c7.19,0,13.96,2.8,19.05,7.88l31.92,31.85c5.11,5.1,7.92,11.88,7.92,19.09v22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2621.43,
    y: 445.03,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2315.53,
    y: 445.03,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 2229.66,
    y: 501.53,
    width: 482.34,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2229.66,
    y: 503.64,
    width: 482.34,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 2229.66,
    y: 506.11,
    width: 482.34,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 2229.66,
    y: 543.1,
    width: 482.34,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2229.66,
    y: 545.21,
    width: 482.34,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 2229.66,
    y: 547.68,
    width: 482.34,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1318.42,603.34c-6.07-3.52-23.11-6.5-24.13-33.68-.76-20.02-.79-45.93-1.04-67.43h-3.09v67.9c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M356.34,180.57c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,297.44c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,296.58c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.36,369.14c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 341,
    height: 82,
    transform: "translate(28.01 374.52)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "166.74 455.56 35.08 455.56 35.08 528.41 67.95 528.41 67.95 567.48 75.74 567.48 75.74 528.41 117.71 528.41 117.71 567.48 125.51 567.48 125.51 528.41 137.16 528.41 166.74 455.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M63.55,567.48H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "134.22 503.13 67.95 503.13 67.95 462.96 152.49 462.96 134.22 503.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M126.68,498.53h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 66,
    y: 560.9,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 66,
    y: 557.61,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M1486.41,452.82h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 1498.46,
    y: 538.32,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 1492.82,
    y: 431.18,
    width: 11.28,
    height: 143.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1521.58,478.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.72,5.71-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1522.23,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1522.34,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1520.52,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1520.63,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1518.81,
    y: 479.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1518.92,
    y: 480.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1521.58,456.09h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.71v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1522.23,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1522.34,
    y: 457.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1520.52,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1520.63,
    y: 457.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1518.81,
    y: 457.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1518.92,
    y: 457.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1030.3,
    y: 418.22,
    width: 13.7,
    height: 104.6,
    transform: "translate(374.21 -455.53) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1267.24,
    y: 418.22,
    width: 13.7,
    height: 104.6,
    transform: "translate(2612.75 240.97) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 419.88,
    width: 1128.74,
    height: 415.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 426.25,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 426.25,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "430.25 8.79 1542.25 8.79 1542.25 6 426.25 6 426.25 409.79 430.25 409.79 430.25 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 1904.29,
    width: 1128.74,
    height: 415.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1910.66,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1910.66,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "1914.66 8.79 3026.66 8.79 3026.66 6 1910.66 6 1910.66 409.79 1914.66 409.79 1914.66 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M356.34,180.57c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,297.44c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,296.58c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 1910.66,
    y: 415.78,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(3862.21 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 1912.46,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(3843.03 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1913.16,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3828.44 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1913.68,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3828.77 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1916.07,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3834.28 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1916.6,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3834.61 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1918.99,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3840.11 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1919.51,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3840.45 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1921.91,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3845.95 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1922.43,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3846.28 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1924.83,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3851.79 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1925.35,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3852.12 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1927.75,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3857.62 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1928.27,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3857.96 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 1931.63,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(3881.38 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1932.33,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3866.79 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1932.85,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3867.12 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1935.25,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3872.63 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1935.77,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3872.96 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1938.17,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3878.46 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1938.69,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3878.8 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1941.09,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3884.3 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1941.61,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3884.63 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1944,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3890.13 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1944.53,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3890.47 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1946.92,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(3895.97 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1947.44,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3896.3 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2450.98,415.78h35.36c1.52,0,2.76,1.24,2.76,2.76v14.13c0,1.52-1.24,2.76-2.76,2.76h-35.36c-1.52,0-2.76-1.24-2.76-2.76v-14.13c0-1.52,1.24-2.76,2.76-2.76Z",
    transform: "translate(4937.32 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 2450.01,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4918.15 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2450.71,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4903.55 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2451.23,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4903.89 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2453.63,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4909.39 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2454.15,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4909.72 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2456.55,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4915.23 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2457.07,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4915.56 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2459.47,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4921.06 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2459.99,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4921.4 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2462.39,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4926.9 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2462.91,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4927.23 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2465.3,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4932.74 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2465.83,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4933.07 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 2469.19,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4956.49 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2469.89,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4941.9 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2470.41,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4942.24 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2472.81,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4947.74 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2473.33,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4948.07 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2475.72,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4953.58 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2476.25,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4953.91 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2478.64,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4959.41 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2479.16,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4959.75 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2481.56,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4965.25 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2482.08,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4965.58 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 2484.48,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4971.09 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2485,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4971.42 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M2988.53,415.78h35.36c1.52,0,2.76,1.24,2.76,2.76v14.13c0,1.52-1.24,2.76-2.76,2.76h-35.36c-1.52,0-2.76-1.24-2.76-2.76v-14.13c0-1.52,1.24-2.76,2.76-2.76Z",
    transform: "translate(6012.43 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 2987.57,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5993.26 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2988.27,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5978.67 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2988.79,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5979 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2991.19,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5984.51 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2991.71,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5984.84 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2994.11,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5990.34 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2994.63,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5990.68 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2997.03,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5996.18 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2997.55,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5996.51 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 2999.94,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6002.01 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 3000.47,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6002.35 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 3002.86,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6007.85 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 3003.38,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6008.18 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 3006.75,
    y: 417.86,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6031.61 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3007.44,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6017.02 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3007.97,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6017.35 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3010.36,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6022.85 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3010.88,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6023.19 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3013.28,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6028.69 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3013.8,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6029.02 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3016.2,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6034.53 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3016.72,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6034.86 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3019.12,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6040.36 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3019.64,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6040.7 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 3022.04,
    y: 419.34,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6046.2 851.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3022.56,
    y: 419.58,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6046.53 842.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 209.05,
    y: 353.65,
    width: 39.07,
    height: 16.37,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 213.75,
    y: 358.27,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M214.65,365.41h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M241.03,358.27h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 215.17,
    y: 359.27,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M381.8,469.8c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M367.39,461.36v108.78c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M357.3,183.86H117.75c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M386.51,467.55c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M76.03,437.33h17.43c.9,0,1.64.73,1.64,1.64v9.6c0,.9-.73,1.64-1.64,1.64h-17.43c-.9,0-1.64-.73-1.64-1.64v-9.6c0-.9.73-1.64,1.64-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M77.85,438.26h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 91.09,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.28,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 88.12,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.31,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 85.15,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.34,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 82.18,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.37,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 79.21,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.4,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 76.23,
    y: 439.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.43,
    y: 439.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M28.95,408h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M42.47,420.32c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M39.77,368.65c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M92.59,352.93c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM123.71,195.56c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M325.46,308.87h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM284.09,195.56c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M34.83,374.82h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M16.73,327.64c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M7.69,297.48c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.21-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M128.21,187.56h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.26-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1372.83,436.19h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2791.83 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 1371.57,
    y: 438.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2766.8 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1372.49,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2747.75 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1373.17,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2748.19 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1376.3,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2755.37 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1376.98,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2755.81 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1380.11,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2762.99 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1380.79,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2763.43 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1383.92,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2770.61 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1384.6,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2771.05 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1387.73,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2778.23 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1388.41,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2778.66 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1391.54,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2785.85 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 1392.22,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2786.28 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 1396.6,
    y: 438.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2816.86 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1397.52,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2797.81 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1398.2,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2798.25 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1401.33,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2805.43 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1402.01,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2805.87 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1405.14,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2813.05 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1405.82,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2813.49 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1408.95,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2820.67 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1409.63,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2821.11 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1412.76,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2828.29 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1413.44,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2828.73 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1416.57,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2835.91 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1417.25,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2836.34 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M794.39,436.19h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(1634.96 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 793.14,
    y: 438.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1609.92 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 794.05,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1590.88 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 794.73,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1591.31 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 797.86,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1598.5 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 798.54,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1598.93 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 801.67,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1606.12 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 802.35,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1606.55 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 805.48,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1613.73 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 806.16,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1614.17 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 809.29,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1621.35 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 809.97,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1621.79 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 813.1,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1628.97 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 813.78,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1629.41 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 818.17,
    y: 438.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1659.99 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 819.08,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1640.94 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 819.76,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1641.37 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 822.89,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1648.56 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 823.57,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1648.99 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 826.7,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1656.18 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 827.38,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1656.61 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 830.51,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1663.8 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 831.19,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1664.23 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 834.32,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1671.41 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 835,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1671.85 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 838.13,
    y: 440.83,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1679.03 898.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 838.81,
    y: 441.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1679.47 886.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-245",
    cx: 15.79,
    cy: 244.72,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M16.55,202.18h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M8.21,210.45h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4AxSingle);
export default __webpack_public_path__ + "static/media/4-Ax Single.9d5ef9e703d728a86943d142c9bfa650.svg";
export { ForwardRef as ReactComponent };